import { GroupInput } from '@/components/v2/group-input'
import { DocumentNumberInput } from '@/components/document-number-input'
import { InternationalPhoneInput } from '@/shared/components/international-phone-input'
import { InputHelperText } from '@/shared/components/input-helper-text'
import { Button, Checkbox, Input } from '@material-tailwind/react'
import { getIn, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

export const MainUserForm = () => {
  const { t } = useTranslation()

  const { values, errors, handleChange, setFieldValue, validateField } = useFormikContext()
  const userId = getIn(values, 'user_attributes.id')
  const hasLocalDocumentNumber = getIn(values, 'user_attributes.has_local_document_number') !== false
  const isDocumentRequired = !userId
  const legalRepresentative = values.legal_representative_attributes || {}
  const safetyManager = values.safety_information?.safety_manager || {}

  const splitFullName = (fullName = '') => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean)
    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ')
    }
  }

  const copyFromSource = async (source = {}) => {
    const { firstName, lastName } = splitFullName(source.full_name)

    await setFieldValue('user_attributes.first_name', firstName)
    await setFieldValue('user_attributes.last_name', lastName)
    await setFieldValue('user_attributes.email', source.email || '')
    await setFieldValue('user_attributes.document_number', source.document_number || '')
    await setFieldValue('user_attributes.phone', source.phone || '')
    await validateField('user_attributes.document_number')
  }

  return (
    <GroupInput
      title={t('company.sections.mainUser')}
      description='Rellena la información del usuario principal que hará ingreso a la plataforma.'
      className='py-8'
    >
      <div className='flex gap-2 mb-4'>
        <Button
          variant='outlined'
          size='sm'
          type='button'
          onClick={() => copyFromSource(safetyManager)}
        >
          Copiar datos de Prevencionista de Riesgos
        </Button>

        <Button
          variant='outlined'
          size='sm'
          type='button'
          onClick={() => copyFromSource(legalRepresentative)}
        >
          Copiar datos de Representante Legal
        </Button>
      </div>

      <div className='grid grid-cols-2 gap-4'>
        <Input
          required
          name="user_attributes.first_name"
          label={t('common.firstName')}
          value={values.user_attributes.first_name}
          onChange={handleChange}
        />

        <Input
          required
          name="user_attributes.last_name"
          label={t('common.lastName')}
          value={values.user_attributes.last_name}
          onChange={handleChange}
        />

        <div>
          <DocumentNumberInput
            required={isDocumentRequired}
            name='user_attributes.document_number'
            label={hasLocalDocumentNumber ? t('documentNumber.one') : 'DNI o pasaporte'}
            value={values.user_attributes.document_number}
            onChange={handleChange}
            error={Boolean(getIn(errors, 'user_attributes.document_number'))}
          />
          <InputHelperText label={getIn(errors, 'user_attributes.document_number')} color='red' />

          <Checkbox
            name='user_attributes.has_local_document_number'
            ripple={false}
            className='hover:before:opacity-0'
            containerProps={{ className: 'p-0' }}
            labelProps={{ className: 'ml-1' }}
            checked={!hasLocalDocumentNumber}
            onChange={async (event) => {
              await setFieldValue(
                'user_attributes.has_local_document_number',
                !event.target.checked
              )
              await validateField('user_attributes.document_number')
            }}
            label='No tiene RUT'
          />
        </div>

        <Input
          required
          name="user_attributes.email"
          label={t('email.one')}
          value={values.user_attributes.email}
          onChange={handleChange}
        />

        <InternationalPhoneInput
          name='user_attributes.phone'
          label={t('phone.one')}
          value={values.user_attributes.phone || ''}
        />
      </div>
    </GroupInput>
  )
}
